import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';
import {Node} from 'reactflow';

import {ProcessFlowchartEditorConfigurator} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorConfigurator';
import {ProcessFlowchartNodeSection} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';
import SearchInput from 'ui-library/SearchInput';

import {ProcessTaskSchemaGraphQL} from '../../../../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaGraphQL';
import {ProcessFlowchartNodeType} from '../processFlowchartConfigEditorConstants';
import {TaskSchemaNodeData} from '../processFlowchartConfigEditorNodeTypes';
import {NODE_TYPE_TO_SECTION} from '../processFlowchartConfigEditorRegistry';
import {FlowchartOptions} from '../processFlowchartConfigEditorUtils';
import {ConfigurableTaskDefinitionGQL} from '../useAllSchemasById';
import {NodeSidepanelSection} from './NodeSidepanelSection';

interface AddNodeSidepanelContentProps {
  allowedNodeTypes: Array<ProcessFlowchartNodeType>;
  taskDefinitionsForSidepanel: Array<ConfigurableTaskDefinitionGQL>;
  addNodeToCanvas: (newNode: Node<TaskSchemaNodeData>) => void;
  options: FlowchartOptions;
  rootTaskSchema: ProcessTaskSchemaGraphQL;
  flowchartEditorConfigurator: ProcessFlowchartEditorConfigurator;
}

/**
 * A sidepanel component that displays all available nodes that can be added to the flowchart
 */
export default function AddNodeSidepanelContent(props: AddNodeSidepanelContentProps): JSX.Element {
  const [searchQuery, setSearchQuery] = useState<string | null>(null);

  const nodeSectionsAndTypes = props.allowedNodeTypes.reduce(
    (acc: Map<ProcessFlowchartNodeSection, Array<ProcessFlowchartNodeType>>, nodeType) => {
      const section = NODE_TYPE_TO_SECTION[nodeType];
      if (!acc.has(section)) {
        acc.set(section, []);
      }
      acc.get(section)!.push(nodeType);
      return acc;
    },
    new Map<ProcessFlowchartNodeSection, Array<ProcessFlowchartNodeType>>()
  );
  return (
    <>
      <div className={css(styles.searchInput)}>
        <SearchInput
          placeholder="Search"
          doSearch={(searchQuery) => {
            setSearchQuery(searchQuery);
          }}
          query={searchQuery}
        />
      </div>
      <>
        {Array.from(nodeSectionsAndTypes.entries()).map(([section, nodeTypes]) => (
          <NodeSidepanelSection
            key={section}
            section={section}
            nodeTypes={nodeTypes}
            taskDefinitionsForSidepanel={props.taskDefinitionsForSidepanel}
            addNodeToCanvas={props.addNodeToCanvas}
            options={props.options}
            searchQuery={searchQuery}
            rootTaskSchema={props.rootTaskSchema}
            flowchartEditorConfigurator={props.flowchartEditorConfigurator}
          />
        ))}
      </>
    </>
  );
}

const styles = StyleSheet.create({
  searchInput: {
    padding: '20px 12px 0px',
  },
});
